export function initToast() {
  const params = new URLSearchParams(window.location.search);
  if (!params.has("success") && !params.has("error")) return;

  const $toast = document.getElementById("toast");
  const $toastMessage = document.getElementById("toast-message");
  const $closeToastBtn = document.getElementById("close-toast");


  if (!$toast || !$toastMessage || !$closeToastBtn) return;
  const showToast = (state: "error" | "success") => {
    if (!$toast || !$toastMessage) return;

    $toast.classList.remove("toast--success", "toast--error");

    $toast.classList.add(`toast--${state}`);
    $toast.classList.add(`toast--visible`);

    if (state === "success") {
      $toastMessage.textContent = "Спасибо! Мы перезвоним вам в течение дня.";
    } else {
      $toastMessage.textContent =
        "Ошибка отправки. Пожалуйста, попробуйте позже.";
    }
  };

  const closeToast = () => {
    $toast.classList.remove("toast--visible", "toast--success", "toast--error");
    window.history.replaceState({}, "", window.location.pathname);
  }

  if (params.has("success")) {
    showToast("success");
  } else if (params.has("error")) {
    showToast("error");
  }

  $closeToastBtn.onclick = closeToast;

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && $toast.classList.contains('toast--visible')) {
      closeToast();
    }
  });
}
